import { useState } from 'react';

const faqs = [
  {
    question: '芭乐视频和91视频、97视频有什么区别？',
    answer: '芭乐视频是91视频和97视频的优质替代平台。相比传统视频网站，芭乐视频拥有更先进的CDN加速技术，实现4K视频秒开不缓冲；更智能的推荐算法，精准匹配你的观影偏好；更清爽的界面设计，让你专注于内容本身。同时，芭乐视频持续扩充片库，涵盖电影、电视剧、综艺、动漫等全品类内容。',
  },
  {
    question: '芭乐视频真的免费吗？需要注册会员吗？',
    answer: '芭乐视频平台上的绝大部分内容都可以免费在线观看，无需注册即可享受高清观影体验。注册会员后还可以享受收藏夹、观看历史同步、个性化推荐等增值功能。我们始终坚持让优质内容触手可及的理念。',
  },
  {
    question: '为什么芭乐视频播放不缓冲？',
    answer: '芭乐视频采用了多项先进技术保障流畅播放：全国超过500个CDN加速节点确保就近接入；自适应码率技术根据你的网络状况动态调整画质；H.265高效编码在保证画质的同时大幅降低带宽需求；智能预加载算法提前缓存你可能观看的内容。这些技术的结合，让你在任何网络环境下都能获得流畅的观影体验。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '芭乐视频全面支持PC电脑、平板、手机等多种设备，覆盖Windows、macOS、iOS、Android等主流操作系统。观影记录和收藏列表自动云端同步，让你在不同设备间无缝切换。推荐使用Chrome、Safari、Edge等现代浏览器获得最佳体验。',
  },
  {
    question: '视频画质怎么样？支持4K吗？',
    answer: '芭乐视频所有视频内容均支持1080P高清画质，大部分热门影片和剧集支持4K超清画质。我们采用行业领先的视频编码技术，在相同带宽下提供更清晰的画面表现。你可以根据网络状况和需求自由切换画质。',
  },
  {
    question: '如何反馈问题或提出建议？',
    answer: '我们非常重视每位用户的反馈。你可以通过关于我们页面的联系表单提交意见和建议，也可以通过官方邮箱与我们取得联系。芭乐视频团队会认真对待每一条反馈，持续优化产品体验。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">常见问题</h2>
          <p className="text-sm text-foreground-600 mt-2">关于芭乐视频，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.question}</span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-700 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}